import React, { useState, useContext, useEffect, ChangeEvent, FormEvent } from 'react';
import { Grid, Box, Divider, Checkbox, FormControlLabel, IconButton, Typography, Button, TextField, InputAdornment, Link } from '@mui/material';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import { useStyles } from '../../styles';
import InputField from '../inputField';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DynamicDialog, { Fields } from '../dialogueBox';
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import { AuthContext } from '../../../../Helpers/Contexts/authContext';
import { createAddress, getBasicProfileSetting, postBasicProfileSetting, updateaddress, updateContactCrm, updatePreferencesandSkills } from '../../../../Utils/apiService';
import { enqueueSnackbar } from 'notistack';
import { AuthUser } from '../../../../interfaces/Contexts';
import { ProfileUserDetails } from '../../../../interfaces/Profile';
import PhoneInput, { PhoneInputProps } from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { parsePhoneNumberFromString, CountryCode } from 'libphonenumber-js';
import { Visibility, VisibilityOff } from "@mui/icons-material";
const allowedFormats = ['image/jpeg', 'image/png', 'image/gif'];
const maxFileSize = 12 * 1024 * 1024; // 12MB in bytes
const maxDimension = 120; // Maximum width/height in pixels
const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const PersonalInformation: React.FunctionComponent<any> = (props) => {
  const classes = useStyles();
  const {
    state: { user },
  } = useContext(AuthContext);
  const userData = user as AuthUser;
  const [hidePhone, setHidePhone] = useState(false);
  console.log(hidePhone, "hidePhonehidePhonehidePhone");
  const [alumniDetails, setalumniDetails] = useState<any>({});
  const [hideMail, setHideMail] = useState(false);
  const [name, setName] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState('');
  const [dialogFields, setDialogFields] = useState<Fields[]>([]);
  const [imageError, setImageError] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [selectedImage, setSelectedImage] = useState<string | null>("https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT8oJh_Li1F9MTL485spsUw1L-cjntjj49vaCWWPZdjPoeZFH5lsCGjQlMZKwr1vNZUz6M&usqp=CAU");
  const [base64Img, setBase64Img] = useState<string | null>(null);
  const [passwordErrMsg, setPasswordErrMsg] = useState<string | null>('');
  const [emailErrMsg, setEmailErrMsg] = useState<string | null>('');
  const [formData, setFormData] = useState<ProfileUserDetails>({
    accountId: userData.applicantId,
    id_pa: '',
    id_ca: '',
    isProfilePicture: true,
    imageName: '',
    imageBlob: null,
    isBasicDetails: true,
    FirstName: '',
    LastName: '',
    currentCity: '',
    email: '',
    password: '',
    phoneNumber: '',
    designation: '',
    isSocialMedia: true,
    linkedinURL: '',
    facebookURL: '',
    twitterURL: '',
    isPermanentAddress: true,
    flatNo_pa: '',
    street_pa: '',
    suburb_pa: '',
    city_pa: '',
    state_pa: '',
    country_pa: '',
      state_ca: '',
    country_ca: '',
    pinCode_pa: '',
    isCurrentAddress: true,
    flatNo_ca: '',
    street_ca: '',
    suburb_ca: '',
    city_ca: '',
    pinCode_ca: '',
    personalOverview: '',
    funFact: '',
    hidePhone: hidePhone,
    hideEmail: hideMail,
  });
  console.log(formData, "formDataformDataformDataformData");
  const updatedFormData: any = { ...formData };
  const [isEditable, setIsEditable] = React.useState(false);
  const [isEditableEmail, setIsEditableEmail] = React.useState(false);
  const [isEditablePassword, setIsEditablePassword] = React.useState(false);
  const [isEditablePersonalOverview, setIsEditablePersonalOverview] = React.useState(false);
  const [isEditableFunFact, setIsEditableFunFact] = React.useState(false);
  const [isEditableDesignation, setIsEditableDesignation] = React.useState(false);
  const [checked, setChecked] = useState(false);
  const [isValid, setIsValid] = useState<boolean>(true);

  const toggleEdit = (name: any) => {
    if (name == 'PhoneNumber') {
      setIsEditable(!isEditable);
      props.setIsFormUnchanged(isEditable);
      if (isEditable == true) {
        const updatedFormData = {
          ...formData,
          isBasicDetails: true,
        };
        postProfileData(updatedFormData, 'Phone Number');
      }
    } else if (name == 'designation') {
      setIsEditableDesignation(!isEditableDesignation);
      props.setIsFormUnchanged(isEditableDesignation);
      if (isEditableDesignation == true) {
        const data = {
          recordId: alumniDetails?.Id,
          Designation__c: formData?.designation,
        };
        updateDesignation(data);
      }
    } else if (name == 'email') {
      setIsEditableEmail(!isEditableEmail);
      props.setIsFormUnchanged(isEditableEmail);

      if (isEditableEmail == true) {
        const updatedFormData = {
          ...formData,
          isBasicDetails: true,
        };
        postProfileData(updatedFormData, 'email');
      }
    } else if (name == 'password') {
      setIsEditablePassword(!isEditablePassword);
      props.setIsFormUnchanged(isEditablePassword);

      if (isEditablePassword == true) {
        const updatedFormData = {
          ...formData,
          isBasicDetails: true,
        };
        postProfileData(updatedFormData, 'password');
      }
    } else if (name == 'personalOverview') {
      setIsEditablePersonalOverview(!isEditablePersonalOverview);
      props.setIsFormUnchanged(isEditablePersonalOverview);
      if (isEditablePersonalOverview == true) {
        const updatedFormData = {
          ...formData,
          isBasicDetails: true,
        };
        postProfileData(updatedFormData, 'personalOverview');
      }
    } else if (name == 'funFact') {
      setIsEditableFunFact(!isEditableFunFact);
      props.setIsFormUnchanged(isEditableFunFact);
      if (isEditableFunFact == true) {
        const updatedFormData = {
          ...formData,
          isBasicDetails: true,
        };
        postProfileData(updatedFormData, 'funFact');
      }
    }
  };

  const updateDesignation = (data: any) => {
    updatePreferencesandSkills(data)
      .then((res) => {
        enqueueSnackbar({
          message: 'Designation updated successfully',
          variant: 'success',
          autoHideDuration: 1000,
        });
        getProfileSetting();

      })
      .catch((err) => {
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        console.error(err);
      });
  };

  const validatePhoneNumber = (phoneNumber: string, countryCode: CountryCode): boolean => {
    try {
      console.log('hgh', phoneNumber, countryCode.toUpperCase());
      const country: any = countryCode.toUpperCase();
      const parsedNumber = parsePhoneNumberFromString(phoneNumber, country);
      console.log('parsedNumber34', parsedNumber);

      return parsedNumber ? parsedNumber.isValid() : false;
    } catch (error) {
      console.error('Error parsing phone number:', error);
      return false;
    }
  };

  const handleChangePhoneInput = (value: string, country: { countryCode: CountryCode }): void => {
    const isValid = validatePhoneNumber(value, country.countryCode);
    console.log('isValid345', isValid);

    setIsValid(isValid);
    setFormData((prevState) => ({
      ...prevState,
      phoneNumber: value,
    }));
  };

  const [showPassword, setShowPassword] = useState(false); // Toggles input type
  const [showPasswordValue, setShowPasswordValue] = useState(true); // Toggles password visibility

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const togglePasswordValue = () => {
    setShowPasswordValue((prev) => !prev);
  };
  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = event.target;
    console.log('name', name, value);
    if (name === 'password') {
      let errors: string[] = [];
      if (value.length < 8) {
        errors.push('Password must be at least 8 characters');
      }
      if (!/[A-Z]/.test(value)) {
        errors.push('Password must include at least one uppercase letter');
      }
      if (!/[a-z]/.test(value)) {
        errors.push('Password must include at least one lowercase letter');
      }
      if (!/[0-9]/.test(value)) {
        errors.push('Password must include at least one number');
      }
      if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
        errors.push('Password must include at least one special character');
      }

      setPasswordErrMsg(errors.join(', '));
    } else if (name == 'email') {
      if (!emailRegex.test(value)) {
        setEmailErrMsg('Invalid email address');
      } else {
        setEmailErrMsg('');
      }
    }
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const postProfileData = (payload: any, name: any) => {
    postBasicProfileSetting(payload)
      .then((res) => {
        if (res?.success) {
          enqueueSnackbar({
            message:
              name == 'Social Media'
                ? 'Social Media Saved Sucessfully'
                : name == 'Permanent Address'
                  ? 'Permanent Address Saved Sucessfully'
                  : name == 'Current Address'
                    ? 'Current Address Saved Sucessfully'
                    : name == 'Phone Number'
                      ? 'Phone Number Added Successfully'
                      : name == 'email'
                        ? 'Email Added Sucessfully'
                        : name == 'password'
                          ? 'Password Added Successfully'
                          : name == 'About me'
                            ? 'About me Updated Successfully'
                            : 'Added Sucessfully',
            variant: 'success',
            autoHideDuration: 1000,
          });
          getProfileSetting();
          setChecked(false);
        } else {
          enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        }
      })
      .catch((err) => {
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        console.error(err);
      });
  };
const getProfileSetting = () => {
  getBasicProfileSetting(userData.applicantId)
    .then((res) => {
      console.log('res68764', res);

      // ✅ Extract country from the API response
      const country =
        res?.currentAddress?.[0]?.Country__c ||
        res?.permanentAddress?.[0]?.Country__c ||
        'Unknown';

      // ✅ Save it to local storage
      localStorage.setItem('country', country);

      setImageError(true);
      setSelectedImage(res.accountDetails.Profile_Picture_URL__c);
      setHidePhone(res.accountDetails?.Hide_Phone__c);
      setHideMail(res.accountDetails?.Hide_Email__c);
      setalumniDetails(res.alumniDetails);

      setFormData({
        imageName: '',
        imageBlob: res.accountDetails.Profile_Picture_URL__c
          ? res.accountDetails.Profile_Picture_URL__c
          : '',
        accountId: userData.applicantId,
        isProfilePicture: false,
        isBasicDetails: false,
        isSocialMedia: false,
        isPermanentAddress: false,
        isCurrentAddress: false,
        FirstName: res.accountDetails.FirstName || '',
        LastName: res.accountDetails.LastName || '',
        currentCity:
          res.accountDetails.Ken_Alumni_CRM__r.records[0].Current_Location__c ||
          '',
        email: res.accountDetails.Email || '',
        password: res.accountDetails.Password1__c || '',
        phoneNumber: res.accountDetails.Phone || '',
        designation:
          res.accountDetails?.Ken_Alumni_CRM__r?.records?.[0]
            ?.Designation__c || '',
        linkedinURL: res.accountDetails.Linkedin_Profile_URL__c || '',
        facebookURL: res.accountDetails.Facebook_URL__c || '',
        twitterURL: res.accountDetails.Twitter_URL__c || '',

        flatNo_pa: res.permanentAddress?.[0]?.House_Number__c || '',
        street_pa: res.permanentAddress?.[0]?.Street__c || '',
        suburb_pa: res.permanentAddress?.[0]?.Suburb__c || '',
        city_pa: res.permanentAddress?.[0]?.City__c || '',
        state_pa: res.permanentAddress?.[0]?.State__c || '',
        country_pa: res.permanentAddress?.[0]?.Country__c || '',
        pinCode_pa: res.permanentAddress?.[0]?.Pincode__c || '',
        id_pa: res.permanentAddress?.[0]?.Id || '',

        flatNo_ca: res.currentAddress?.[0]?.House_Number__c || '',
        id_ca: res.currentAddress?.[0]?.Id || '',
        street_ca: res.currentAddress?.[0]?.Street__c || '',
        suburb_ca: res.currentAddress?.[0]?.Suburb__c || '',
        city_ca: res.currentAddress?.[0]?.City__c || '',
        pinCode_ca: res.currentAddress?.[0]?.Pincode__c || '',
        state_ca: res.currentAddress?.[0]?.State__c || '',
        country_ca: res.currentAddress?.[0]?.Country__c || '',
        personalOverview: res.accountDetails.Personal_Overview__c || '',
        funFact: res.accountDetails.Fun_Fact__c || '',
        hidePhone: res.accountDetails.Hide_Phone__c || false,
        hideEmail: res.accountDetails.Hide_Email__c || false,
      });
    })
    .catch((err) => {
      console.error(err);
    });
};


  //image
  console.log('selectedImage342', selectedImage);
  const validateImage = (file: File): Promise<string | null> => {
    return new Promise((resolve) => {
      const isValidFormat = allowedFormats.includes(file.type);
      if (!isValidFormat) {
        resolve('File format not supported. Please upload a JPEG, PNG, or GIF image.');
        setError('File format not supported. Please upload a JPEG, PNG, or GIF image.');
        return;
      }

      if (file.size > maxFileSize) {
        resolve('File size exceeds 12MB.');
        setError('File size exceeds 12MB.');
        return;
      }

      resolve(null); // No error, proceed with resizing
    });
  };
  const cropAndResizeImage = (file: File, size: number = 120): Promise<string> => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = (event) => {
        img.src = event.target?.result as string;
      };

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        const minSide = Math.min(img.width, img.height); // Get the smallest side for cropping
        const startX = (img.width - minSide) / 2;
        const startY = (img.height - minSide) / 2;

        canvas.width = size;
        canvas.height = size;

        if (ctx) {
          ctx.drawImage(img, startX, startY, minSide, minSide, 0, 0, size, size);
          resolve(canvas.toDataURL('image/jpeg')); // Convert to Base64
        } else {
          reject('Failed to process image.');
        }
      };

      img.onerror = () => {
        reject('Failed to load the image. Please try again.');
      };
    });
  };
  const convertToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        if (reader.result) {
          resolve(reader.result as string);
        } else {
          reject('Failed to convert image to base64.');
        }
      };
      reader.onerror = () => {
        reject('Failed to read the file.');
      };
    });
  };

const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
  const file = event.target.files?.[0];

  if (file) {
    // Check if the file exceeds 12MB
    const MAX_FILE_SIZE_MB = 12; // 12 MB
    const fileSizeInMB = file.size / (1024 * 1024); // Convert size to MB

    if (fileSizeInMB > MAX_FILE_SIZE_MB) {
      enqueueSnackbar({ message: 'File exceeds the 12MB limit', variant: 'error', autoHideDuration: 1000 });
      event.target.value = ''; // Reset the file input
      return;
    }

    // Validate image format (you can call your existing validation function here)
    const validationError = await validateImage(file);
    if (validationError) {
      enqueueSnackbar({ message: 'Unsupported file format', variant: 'error', autoHideDuration: 1000 });
      event.target.value = ''; // Reset the file input
      return;
    }

    setError('');
    setImageError(true);

    try {
      // Crop and resize image
      const resizedBase64 = await cropAndResizeImage(file);
      setSelectedImage(resizedBase64);
      const splitData = resizedBase64.split(',');
      setBase64Img(resizedBase64);
      setFormData((prevState) => ({
        ...prevState,
        imageName: file.name,
        imageBlob: splitData[1],
      }));

      const payLoad = {
        ...formData,
        imageName: file.name,
        imageBlob: splitData[1],
        isProfilePicture: true,
      };

      // Post the profile picture
      postBasicProfileSetting(payLoad)
        .then((res) => {
          if (res?.success) {
            enqueueSnackbar({ message: 'Profile picture updated successfully', variant: 'success', autoHideDuration: 1000 });
            getProfileSetting();
          } else {
            enqueueSnackbar({ message: 'Upload failed', variant: 'error', autoHideDuration: 1000 });
          }
        })
        .catch((err) => {
          enqueueSnackbar({ message: 'Upload error', variant: 'error', autoHideDuration: 1000 });
          console.error(err);
        });
    } catch (error) {
      enqueueSnackbar({ message: error as string, variant: 'error', autoHideDuration: 1000 });
    }
  }
};


  const handleDialogOpen = (title: string, fields: Fields[]) => {
    setDialogTitle(title);
    setDialogFields(fields);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleDialogSave = () => {
    const updatedFormData: any = { ...formData };
    console.log('dialogFields', dialogFields);

    dialogFields.forEach((link: any) => {
      if (link.name in updatedFormData) {
        updatedFormData[link.name as keyof ProfileUserDetails] = link.value;
      }
    });
    console.log('updatedFormData', updatedFormData);

    if (dialogFields[0].fieldName == 'Social Media') {
      const updatedFormDatas = {
        ...updatedFormData,
        isSocialMedia: true,
      };
      postProfileData(updatedFormDatas, 'Social Media');
    }
    else if (dialogFields[0].fieldName == 'About me') {
      const updatedFormDatas = {
        ...updatedFormData,
        isBasicDetails: true,
      };
      postProfileData(updatedFormDatas, 'About me');
    }
    else if (checked == true) {
      if (updatedFormData?.id_ca) {
        const updatedFormDatas = {
          "Contact__c": userData.applicantId,
          "Address_Type__c": "Mailing",
          "City__c": updatedFormData?.city_pa,
          "House_Number__c": updatedFormData?.flatNo_pa,
            "State__c": updatedFormData?.state_pa,
          "Country__c": updatedFormData?.country_pa,
          "Pincode__c": updatedFormData?.pinCode_pa,
          "Street__c": updatedFormData?.street_pa,
          "Suburb__c": updatedFormData?.suburb_pa,
          "recordId": updatedFormData?.id_ca,
        };
        updateaddress(updatedFormDatas).then((res) => {
          if (res?.status === 200) {
            getProfileSetting();
            enqueueSnackbar({
              message: 'We have made the current address your permanent address successfully.',
              variant: 'success',
              autoHideDuration: 1000,
            });
          } else {
            enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
          }
        })
          .catch((err) => {
            enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
            console.error(err);
          });
      }
      else {
        const updatedFormDatas = {
          "Contact__c": userData.applicantId,
          "Address_Type__c": "Mailing",
          "City__c": updatedFormData?.city_pa,
          "State__c": updatedFormData?.state_pa,
          "Country__c": updatedFormData?.country_pa,
          "House_Number__c": updatedFormData?.flatNo_pa,
          "Pincode__c": updatedFormData?.pinCode_pa,
          "Street__c": updatedFormData?.street_pa,
          "Suburb__c": updatedFormData?.suburb_pa,
        };
        createAddress(updatedFormDatas).then((res) => {
          if (res?.success) {
            getProfileSetting();
            enqueueSnackbar({
              message: 'We have made the current address your permanent address successfully.',
              variant: 'success',
              autoHideDuration: 1000,
            });
          } else {
            enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
          }
        })
          .catch((err) => {
            enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
            console.error(err);
          });
      }
    }
    else if (dialogFields[0].fieldName == 'Permanent Address') {
      if (updatedFormData?.id_pa) {
        const updatedFormDatas = {
          "Contact__c": userData.applicantId,
          "Address_Type__c": "Permanent",
          "City__c": updatedFormData?.city_pa,
            "State__c": updatedFormData?.state_pa,
          "Country__c": updatedFormData?.country_pa,
          "House_Number__c": updatedFormData?.flatNo_pa,
          "Pincode__c": updatedFormData?.pinCode_pa,
          "Street__c": updatedFormData?.street_pa,
          "Suburb__c": updatedFormData?.suburb_pa,
          "recordId": updatedFormData?.id_pa,
        };
        console.log(updatedFormData, "updatedFormDataupdatedFormDataupdatedFormData");
        updateaddress(updatedFormDatas).then((res) => {
          if (res?.status === 200) {
            getProfileSetting();
            enqueueSnackbar({
              message: 'Permanent Address Saved Sucessfully',
              variant: 'success',
              autoHideDuration: 1000,
            });
          } else {
            enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
          }
        })
          .catch((err) => {
            enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
            console.error(err);
          });
      }
      else {
        const updatedFormDatas = {
          "Contact__c": userData.applicantId,
          "Address_Type__c": "Permanent",
          "City__c": updatedFormData?.city_pa,
            "State__c": updatedFormData?.state_pa,
          "Country__c": updatedFormData?.country_pa,
          "House_Number__c": updatedFormData?.flatNo_pa,
          "Pincode__c": updatedFormData?.pinCode_pa,
          "Street__c": updatedFormData?.street_pa,
          "Suburb__c": updatedFormData?.suburb_pa,
        };
        createAddress(updatedFormDatas).then((res) => {
          if (res?.success) {
            getProfileSetting();
            enqueueSnackbar({
              message: 'Permanent Address Saved Sucessfully',
              variant: 'success',
              autoHideDuration: 1000,
            });
          } else {
            enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
          }
        })
          .catch((err) => {
            enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
            console.error(err);
          });
      }
    }
    else if (dialogFields[0].fieldName == 'Current Address') {
      if (updatedFormData?.id_ca) {
        const updatedFormDatas = {
          "Contact__c": userData.applicantId,
          "Address_Type__c": "Mailing",
          "City__c": updatedFormData?.city_ca,
            "State__c": updatedFormData?.state_ca,
          "Country__c": updatedFormData?.country_ca,
          "House_Number__c": updatedFormData?.flatNo_ca,
          "Pincode__c": updatedFormData?.pinCode_ca,
          "Street__c": updatedFormData?.street_ca,
          "Suburb__c": updatedFormData?.suburb_ca,
          "recordId": updatedFormData?.id_ca,
        };
        console.log(updatedFormData, "updatedFormDataupdatedFormDataupdatedFormData");
        updateaddress(updatedFormDatas).then((res) => {
          if (res?.status === 200) {
            getProfileSetting();
            enqueueSnackbar({
              message: 'Current Address Saved Sucessfully.',
              variant: 'success',
              autoHideDuration: 1000,
            });
          } else {
            enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
          }
        })
          .catch((err) => {
            enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
            console.error(err);
          });
      }
      else {
        const updatedFormDatas = {
          "Contact__c": userData.applicantId,
          "Address_Type__c": "Mailing",
          "City__c": updatedFormData?.city_ca,
            "State__c": updatedFormData?.state_ca,
          "Country__c": updatedFormData?.country_ca,
          "House_Number__c": updatedFormData?.flatNo_ca,
          "Pincode__c": updatedFormData?.pinCode_ca,
          "Street__c": updatedFormData?.street_ca,
          "Suburb__c": updatedFormData?.suburb_ca,
        };
        createAddress(updatedFormDatas).then((res) => {
          if (res?.success) {
            getProfileSetting();
            enqueueSnackbar({
              message: 'Current Address Saved Sucessfully.',
              variant: 'success',
              autoHideDuration: 1000,
            });
          } else {
            enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
          }
        })
          .catch((err) => {
            enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
            console.error(err);
          });
      }
    }
    setDialogOpen(false);
  };
  const socialMediaFields: Fields[] = [
    { label: 'LinkedIn Profile Link', name: 'linkedinURL', value: formData.linkedinURL, type: 'text', fieldName: 'Social Media' },
    // { label: 'Facebook Profile Link', name: 'facebookURL', value: formData.facebookURL, type: 'text', fieldName: 'Social Media' },
    { label: 'Twitter Profile Link', name: 'twitterURL', value: formData.twitterURL, type: 'text', fieldName: 'Social Media' },
  ];

  const aboutMeFields: Fields[] = [
    { label: 'Tell us about yourself', name: 'personalOverview', value: formData.personalOverview, type: 'text', fieldName: 'About me', multiline: true },
  ];

  const permanentAddressFields: Fields[] = [
    { label: 'House/flat no', name: 'flatNo_pa', value: formData.flatNo_pa, type: 'text', fieldName: 'Permanent Address' },
    { label: 'Street', name: 'street_pa', value: formData.street_pa, type: 'text', fieldName: 'Permanent Address' },
    { label: 'Suburb', name: 'suburb_pa', value: formData.suburb_pa, type: 'text', fieldName: 'Permanent Address' },
    { label: 'City', name: 'city_pa', value: formData.city_pa, type: 'text', fieldName: 'Permanent Address' },
    { label: 'State', name: 'state_pa', value: formData.state_pa, type: 'text', fieldName: 'Permanent Address' },
    { label: 'Country', name: 'country_pa', value: formData.country_pa, type: 'text', fieldName: 'Permanent Address' },
    { label: 'Pincode', name: 'pinCode_pa', value: formData.pinCode_pa, type: 'text', fieldName: 'Permanent Address' },


  ];

  const currentAddressFields: Fields[] = [
    { label: 'House/flat no', name: 'flatNo_ca', value: checked ? formData.flatNo_pa : formData.flatNo_ca, type: 'text', fieldName: 'Current Address' },
    { label: 'Street', name: 'street_ca', value: checked ? formData.street_pa : formData.street_ca, type: 'text', fieldName: 'Current Address' },
    { label: 'Suburb', name: 'suburb_ca', value: checked ? formData.suburb_pa : formData.suburb_ca, type: 'text', fieldName: 'Current Address' },
    { label: 'City', name: 'city_ca', value: checked ? formData.city_pa : formData.city_ca, type: 'text', fieldName: 'Current Address' },
    { label: 'State', name: 'state_ca', value: checked ? formData.state_pa : formData.state_ca, type: 'text', fieldName: 'Current Address' },
     { label: 'Country', name: 'country_ca', value: checked ? formData.country_pa : formData.country_pa, type: 'text', fieldName: 'Current Address' },
    { label: 'Pincode', name: 'pinCode_ca', value: checked ? formData.pinCode_pa : formData.pinCode_ca, type: 'text', fieldName: 'Current Address' },
  ];

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setChecked?.(isChecked);
    console.log('Checkbox changed, new value:', isChecked);
    if (isChecked == true) {
      getProfileSetting();
    }
  };

  useEffect(() => {
    getProfileSetting();
  }, [checked]);

  console.log('checked35345', checked);

  const hidePhonenumber = () => {
    const updatedFormData: any = {
      ...formData,
      isBasicDetails: true,
      hidePhone: !hidePhone
    };
    postBasicProfileSetting(updatedFormData)
      .then((res) => {
        if (res?.success == true) {
          enqueueSnackbar({ message: 'Phone number hidden successfully', variant: 'success', autoHideDuration: 1000 });
          getProfileSetting();
        }
      })
      .catch((err) => {
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        console.error(err);
      });
  }

  const hideEmailId = () => {
    const updatedFormData: any = {
      ...formData,
      isBasicDetails: true,
      hideEmail: !hideMail
    };
    postBasicProfileSetting(updatedFormData)
      .then((res) => {
        if (res?.success == true) {
          enqueueSnackbar({ message: 'Phone number hidden successfully', variant: 'success', autoHideDuration: 1000 });
          getProfileSetting();
        }
      })
      .catch((err) => {
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        console.error(err);
      });
  }

  const currentAddressUpdate = () => {
    if (updatedFormData?.id_ca) {
      const updatedFormDatas = {
        "Contact__c": userData.applicantId,
        "Address_Type__c": "Mailing",
        "City__c": updatedFormData?.city_pa,
          "State__c": updatedFormData?.state_pa,
          "Country__c": updatedFormData?.country_pa,
        "House_Number__c": updatedFormData?.flatNo_pa,
        "Pincode__c": updatedFormData?.pinCode_pa,
        "Street__c": updatedFormData?.street_pa,
        "Suburb__c": updatedFormData?.suburb_pa,
        "recordId": updatedFormData?.id_ca,
      };
      console.log(updatedFormData, "updatedFormDataupdatedFormDataupdatedFormData");
      updateaddress(updatedFormDatas).then((res) => {
        if (res?.status === 200) {
          getProfileSetting();
          enqueueSnackbar({
            message: 'Current Address Saved Sucessfully.',
            variant: 'success',
            autoHideDuration: 1000,
          });
        } else {
          enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        }
      })
        .catch((err) => {
          enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
          console.error(err);
        });
    }
    else {
      const updatedFormDatas = {
        "Contact__c": userData.applicantId,
        "Address_Type__c": "Mailing",
        "City__c": updatedFormData?.city_pa,
          "State__c": updatedFormData?.state_pa,
          "Country__c": updatedFormData?.country_pa,
        "House_Number__c": updatedFormData?.flatNo_pa,
        "Pincode__c": updatedFormData?.pinCode_pa,
        "Street__c": updatedFormData?.street_pa,
        "Suburb__c": updatedFormData?.suburb_pa,
      };
      createAddress(updatedFormDatas).then((res) => {
        if (res?.success) {
          getProfileSetting();
          enqueueSnackbar({
            message: 'Current Address Saved Sucessfully.',
            variant: 'success',
            autoHideDuration: 1000,
          });
        } else {
          enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        }
      })
        .catch((err) => {
          enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
          console.error(err);
        });
    }
  }
  return (
    <>
      <Box className={classes.entireContainer} sx={{ px: 2 }}>
        {/* <Typography
          sx={{
            fontSize: '15px',
            p: 2,
            fontWeight: 'bold',
            '@media (min-width: 1280px) and (max-width: 1300px)': {
              fontSize: '13px !important',
            },
          }}
          textAlign="start"
        >
          Personal Information
        </Typography>
        <Divider className={classes.divider} /> */}
        <div style={{ padding: '30px 0px' }} className={`${classes.personalInfoBox} scrollbar-cusgray`}>
          <Grid container className={classes.sepContainer2}>
            <Grid item xs={12} sm={12} md={12} textAlign="start">
              <Typography className={classes.rightHeadings}>Basic Details</Typography>
            </Grid>
            <Grid item md={2} textAlign="start">
              <Box position="relative" display="inline-block">
                {imageError ? (
                  <img src={selectedImage ? selectedImage : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT8oJh_Li1F9MTL485spsUw1L-cjntjj49vaCWWPZdjPoeZFH5lsCGjQlMZKwr1vNZUz6M&usqp=CAU"} alt="ProfileImg" style={{ width: '90px', height: '90px', borderRadius: '8px' }} />
                ) : (
                  <AccountBoxOutlinedIcon style={{ width: '90px', height: '90px', borderRadius: '8px' }} />
                )}
                <div style={{ position: 'relative' }}>
                  <input accept="image/*" style={{ display: 'none' }} id="icon-button-file" type="file" onChange={handleFileUpload} />
                  <label htmlFor="icon-button-file">
                    <IconButton
                      component="span"
                      sx={{
                        position: 'absolute',
                        bottom: 28,
                        right: 5,
                        color: 'black',
                        backgroundColor: 'white',
                        borderRadius: '2.13px',
                        '&:hover': {
                          backgroundColor: 'white',
                        },
                        height: '19px',
                        width: '19px',
                      }}
                    >
                      <ModeEditOutlinedIcon style={{ fontSize: '15px' }} />
                    </IconButton>
                  </label>
                </div>
              </Box>
            </Grid>
            <Grid item md={10} textAlign="start">
              <Typography sx={{ fontSize: 12, fontWeight: 500, mt: 4.5 }}>Edit profile picture</Typography>
              <Typography sx={{ fontSize: 12 }}>Max:120px | 12mb</Typography>
              <Typography sx={{ color: 'red' }}>{error && <p style={{ color: 'red', fontSize: '12px' }}>{error}</p>}</Typography>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <InputField label="First Name" name="FirstName" value={formData.FirstName} onChange={handleChange} />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <InputField label="Last Name" name="LastName" value={formData.LastName} onChange={handleChange} />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <Typography
                  variant="subtitle1"
                  textAlign="start"
                  sx={{
                    fontWeight: '500',
                    fontSize: '12px',
                    color: '#373A45',
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      fontSize: '11px !important',
                    },
                  }}
                >
                  Email ID
                </Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  value={hideMail ? '....' : formData.email}
                  name="email"
                  onChange={handleChange}
                  margin="normal"
                  error={Boolean(emailErrMsg)}
                  helperText={emailErrMsg}
                  InputProps={{
                    readOnly: !isEditableEmail,
                    sx: {
                      background: '#fff',
                      height: '36px',
                      '& .MuiInputBase-input': {
                        fontSize: '12px',
                        fontWeight: 400,
                      },
                    },
                  }}
                  sx={{ margin: '10px 0px', background: '#fff' }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <Typography
                  sx={{
                    textAlign: 'left',
                    mt: 0.5,
                    fontWeight: 500,
                    fontSize: 12,
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      fontSize: '11px !important',
                    },
                  }}
                >
                  Phone Number
                </Typography>
            <Box sx={{ mt: 1.2 }}>
  <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
    {hidePhone ?
      <TextField
        fullWidth
        variant="outlined"
        value={"••••••"}
        InputProps={{
          readOnly: !isEditablePassword,
          sx: {
            background: '#fff',
            height: '36px',
            '& .MuiInputBase-input': {
              fontSize: '12px',
              fontWeight: 400,
            },
          },
        }}
        name="password"
        sx={{ background: '#fff' }}
      /> :
      <PhoneInput
        country={'in'} // Set default country to India ('in')
        value={hidePhone ? '+91 ....' : formData.phoneNumber}
        onChange={handleChangePhoneInput}
        inputStyle={{
          height: '36px',
          fontSize: '12px',
          paddingRight: '50px',
          backgroundColor: 'white',
          width: '100%',
          textAlign: 'left',
          paddingLeft: 65,
          border: isEditable ? '1.5px solid black' : '', // Border only when editable
          borderRadius: isEditable ? '5px' : ''
        }}
        buttonStyle={{
          height: '36px',
          padding: '0 10px',
          border: isEditable ? '1.5px solid black' : '1px solid #ccc', // Border when editable
          borderRadius: isEditable ? '5px' : ''
        }}
        inputProps={{
          name: 'phone',
          required: true,
          autoFocus: true,
          id: 'phone',
          readOnly: !isEditable, // Only editable if isEditable is true
        }}
        containerStyle={{
          width: '100%',
        }}
        dropdownStyle={{
          textAlign: 'left',
          display: isEditable ? 'block' : 'none', // Ensure dropdown is visible only when editable
        }}
      />}
    {hidePhone ? null :
      <div
        onClick={() => toggleEdit('PhoneNumber')}
        style={{
          position: 'absolute',
          right: '10px',
          top: '50%',
          transform: 'translateY(-50%)',
          fontSize: 12,
          cursor: 'pointer',
          textDecoration: 'underline',
          color: 'rgb(48, 97, 255)',
          fontWeight: 450,
        }}
      >
        {isEditable ? 'Save' : 'Edit'}
      </div>}
  </div>
  <div style={{ color: 'red', textAlign: 'left', marginTop: 5 }}>{isValid ? '' : 'Invalid phone number'}</div>
</Box>

                {/* <InputField label="Current City/Town of Residence" name="currentCity" value={formData.city_ca || ''} onChange={handleChange} />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}> */}
            
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <Typography
                  sx={{
                    textAlign: 'left',
                    mt: 0.5,
                    fontWeight: 500,
                    fontSize: 12,
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      fontSize: '11px !important',
                    },
                  }}
                >
                  Designation
                </Typography>
                <Box sx={{ mt: 1.2 }}>
                  <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      value={formData?.designation}
                      name="designation"
                      onChange={handleChange}
                      InputProps={{
                        readOnly: !isEditableDesignation,
                        sx: {
                          background: '#fff',
                          height: '36px',
                          '& .MuiInputBase-input': {
                            fontSize: '12px',
                            fontWeight: 400,
                          },
                        },
                      }}
                      sx={{
                        background: '#fff',
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            border: isEditableDesignation ? '1.5px solid black' : '1px solid #ccc',
                          },
                        },
                      }}
                    />
                    <div
                      onClick={() => toggleEdit('designation')}
                      style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        fontSize: 12,
                        cursor: 'pointer',
                        textDecoration: 'underline',
                        color: 'rgb(48, 97, 255)',
                        fontWeight: 450,
                      }}
                    >
                      {isEditableDesignation ? 'Save' : 'Edit'}
                    </div>
                  </div>
                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid container className={classes.sepContainer2}>
            <Grid item xs={8} textAlign="start">
              <Typography className={classes.rightHeadings}>About me</Typography>
            </Grid>
            <Grid item xs={4} textAlign="end">
              <Button
                variant="contained"
                startIcon={<EditOutlinedIcon sx={{ fontSize: '12px' }} />}
                onClick={() => handleDialogOpen('About me', aboutMeFields)}
                sx={{
                  fontSize: '12px',
                  color: '#373A45',
                  borderColor: '#373A45',
                  boxShadow: 'none',
                  background: '#E8EBF3',
                  '&:hover': {
                    background: '#E8EBF3', // Same background on hover
                    boxShadow: 'none', // Prevent shadow on hover
                  },
                }}
              >
                Edit
              </Button>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography sx={{ fontSize: "12px", fontWeight: 500, color: "#373A45", textAlign: "left" }}>Personal Overview</Typography>
              <TextField
                name="personalOverview"
                value={formData.personalOverview}
                onChange={handleChange}
                fullWidth
                multiline
                minRows={2}
                maxRows={4}
                variant="outlined"
                placeholder=""
                sx={{ margin: '10px 0px', background: '#fff', fontSize: "14px" }}
                InputLabelProps={{ shrink: false }}
                InputProps={{
                  readOnly: true,
                  sx: {
                    background: '#ffffff',
                    '& .MuiInputBase-input': {
                      fontSize: '14px',
                      fontWeight: 400,
                    },
                  },
                }}
              />
            </Grid>
          </Grid>

          <Grid container className={classes.sepContainer2}>
            <Grid item xs={8} textAlign="start">
              <Typography className={classes.rightHeadings}>Social Media</Typography>
            </Grid>
            <Grid item xs={4} textAlign="end">
              <Button
                variant="contained"
                startIcon={<EditOutlinedIcon sx={{ fontSize: '12px' }} />}
                onClick={() => handleDialogOpen('Social media links', socialMediaFields)}
                sx={{
                  fontSize: '12px',
                  color: '#373A45',
                  borderColor: '#373A45',
                  boxShadow: 'none',
                  background: '#E8EBF3',
                  '&:hover': {
                    background: '#E8EBF3', // Same background on hover
                    boxShadow: 'none', // Prevent shadow on hover
                  },
                }}
              >
                Edit
              </Button>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <InputField label="Linkedin Profile Link " name="linkedinURL" value={formData.linkedinURL} onChange={handleChange} />
            </Grid>
            {/* <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <InputField label="Facebook Profile Link" name="facebookURL" value={formData.facebookURL} onChange={handleChange} />
            </Grid> */}
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <InputField label="Twitter (X) Profile Link" name="twitterURL" value={formData.twitterURL} onChange={handleChange} />
            </Grid>
          </Grid>
          <Grid container className={classes.sepContainer2}>
            <Grid item xs={8} textAlign="start">
              <Typography className={classes.rightHeadings}>Permanent Address</Typography>
            </Grid>
            <Grid item xs={4} textAlign="end">
              <Button
                variant="contained"
                startIcon={<EditOutlinedIcon sx={{ fontSize: '12px' }} />}
                onClick={() => handleDialogOpen('Permanent Address', permanentAddressFields)}
                sx={{
                  fontSize: '12px',
                  color: '#373A45',
                  borderColor: '#373A45',
                  background: '#E8EBF3',
                  boxShadow: 'none',
                  '&:hover': {
                    background: '#E8EBF3', // Same background on hover
                    boxShadow: 'none', // Prevent shadow on hover
                  },
                }}
              >
                Edit
              </Button>
            </Grid>
            <br />
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <InputField label="House/flat no" name="flatNo_pa" value={formData.flatNo_pa} onChange={handleChange} />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <InputField label="Street" name="street_pa" value={formData.street_pa} onChange={handleChange} />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}></Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <InputField label="Suburb" name="suburb_pa" value={formData.suburb_pa} onChange={handleChange} />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <InputField label="City" name="city_pa" value={formData.city_pa} onChange={handleChange} />
            </Grid>
             <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <InputField label="State" name="state_pa" value={formData.state_pa} onChange={handleChange} />
            </Grid>
             <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <InputField label="Country" name="country_pa" value={formData.country_pa} onChange={handleChange} />
            </Grid>
            
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <InputField label="Pincode" name="pinCode_pa" value={formData.pinCode_pa} onChange={handleChange} />
            </Grid>
          </Grid>
          <Grid container className={classes.sepContainer2}>
            <Grid item xs={12} sm={12} md={7} lg={7} xl={7} textAlign="start">
              <Typography className={classes.rightHeadings}>Current Address</Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <FormControlLabel
                control={<Checkbox size="small" checked={checked} onChange={handleCheckboxChange} />}
                label={<Typography sx={{ fontSize: 12 }}>Same as permanent Address</Typography>}
                onClick={() => {
                  currentAddressUpdate();
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={2} lg={2} xl={2} textAlign="end">
              <Button
                variant="contained"
                startIcon={<EditOutlinedIcon sx={{ fontSize: '12px' }} />}
                onClick={() => handleDialogOpen('Current Address', currentAddressFields)}
                sx={{
                  fontSize: '12px',
                  color: '#373A45',
                  borderColor: '#373A45',
                  boxShadow: 'none',
                  background: '#E8EBF3',
                  '&:hover': {
                    background: '#E8EBF3', // Same background on hover
                    boxShadow: 'none', // Prevent shadow on hover
                  },
                }}
              >
                Edit
              </Button>
            </Grid>
            <br />
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <InputField label="House/flat no" name="flatNo_ca" value={formData.flatNo_ca} onChange={handleChange} />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <InputField label="Street" name="street_ca" value={formData.street_ca} onChange={handleChange} />
            </Grid>
            <Grid item lg={4}></Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <InputField label="Suburb" name="suburb_ca" value={formData.suburb_ca} onChange={handleChange} />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <InputField label="City" name="city_ca" value={formData.city_ca} onChange={handleChange} />
            </Grid>
             <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <InputField label="State" name="state_ca" value={formData.state_ca} onChange={handleChange} />
            </Grid>
             <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <InputField label="Country" name="country_ca" value={formData.country_ca} onChange={handleChange} />
            </Grid>
            
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <InputField label="Pincode" name="pinCode_ca" value={formData.pinCode_ca} onChange={handleChange} />
            </Grid>
          </Grid>

        </div>
      </Box>
      <DynamicDialog
        open={dialogOpen}
        title={dialogTitle}
        onClose={handleDialogClose}
        onSave={handleDialogSave}
        fields={dialogFields}
        cancelButtonText="Discard changes"
        saveButtonText="Save changes"
        setChecked={setChecked}
        checked={checked}
        handleCheckboxChange={handleCheckboxChange}
        formData={formData}
        plainCancelButton={true}
      />
    </>
  );
};
export default PersonalInformation;
